var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.numOfUnreadAlerts > 0)?_c('div',{staticClass:"nav-pending-alerts flex-centerize",class:{ pad_alerts: _vm.pad, minimized: _vm.minimized }},[_c('h5',{staticClass:"nav-pending-alerts-text"},[_vm._v(_vm._s(_vm.numOfUnreadAlerts))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }